import { apiFetch } from '$lib/api/helpers';

export async function fetchElectricalLayout(unitId: number) {
	return apiFetch<unknown>(`/units/${unitId}/electrical_summary/`);
}
